import { createAsyncThunk } from "@reduxjs/toolkit";
import { AXIOS_RESERVATION } from "../../../../utils/axiosInterceptors";
import { config } from "../../../../config";

export const getcomponent = createAsyncThunk(
  "categories/getcomponent",
  async (state, { getState, rejectWithValue, dispatch }) => {
    try {
      let { data } = await AXIOS_RESERVATION.get(`getcomponent`);
      console.log("data", data);
      return data;
    } catch (err) {
      throw rejectWithValue({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong please try again later",
        },
      });
    }
  }
);

export const addnewcomponent = createAsyncThunk(
  "categories/addcomponent",
  async (state, { getState, rejectWithValue, dispatch }) => {
    let { CB, ...others } = state;
    others.hotelId = config.HOTELID;

    var headers = {
      "Access-Control-Allow-Origin": "*",
    };

    try {
      let { data } = await AXIOS_RESERVATION.post(`addcomponent`, others, {
        headers,
      });

      if (data?.success == false) {
        CB && CB(data);
      } else {
        CB && CB(data);
        dispatch(getcomponent());

        return data;
      }
    } catch (err) {
      CB && CB(err);
      throw rejectWithValue({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong please try again later",
        },
      });
    }
  }
);

export const editcomponent = createAsyncThunk(
  "categories/updatecomponent",
  async (state, { getState, rejectWithValue, dispatch }) => {
    let { CB, ...others } = state;

    try {
      let { data } = await AXIOS_RESERVATION.post(`updatecomponent`, others);

      if (data?.success == false) {
        CB && CB(data);
      } else {
        CB && CB(data);
        dispatch(getcomponent());

        return data;
      }
    } catch (err) {
      throw rejectWithValue({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong Please try again later",
        },
      });
    }
  }
);

export const removecomponent = createAsyncThunk(
  "categories/removecomponent",
  async (state, { getState, rejectWithValue, dispatch }) => {
    let { id, CB } = state;

    var headers = {
      _id: id,
      "Access-Control-Allow-Origin": "*",
    };

    try {
      let { data } = await AXIOS_RESERVATION.delete(`removecomponent`, {
        headers,
      });

      if (data?.success == false) {
        CB && CB(data);
      } else {
        CB && CB(data);
        dispatch(getcomponent());

        return data;
      }
    } catch (err) {
      throw rejectWithValue({
        status: {
          apiSuccess: false,
          apiMessage:
            err?.result?.message ||
            "Something went wrong please try again later",
        },
      });
    }
  }
);
